import repeatData from './repeatData'

const zhCN = { repeatData: repeatData.zhCN }
const enUS = { repeatData: repeatData.enUS }
export default { zhCN, enUS }